export default __webpack_public_path__ + "static/media/frank-linkedin-closeup.b4de5c4a.jpg";